import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AlertService } from 'app/core/alert.service';
import { Alert, AlertType } from 'app/shared/alert/alert';
import { Subscription } from 'rxjs';

@Component({
  selector: 'xcm-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
  standalone: false
})
export class AlertComponent implements OnInit, OnDestroy {
  private alertService = inject(AlertService);
  private cdr = inject(ChangeDetectorRef);

  @Input() timeout: number;
  private alertSub: Subscription;
  alerts: Alert[] = [];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}

  ngOnInit() {
    this.alertSub = this.alertService.getAlert().subscribe((alert: Alert) => {
      if (!alert) {
        // clear alerts when an empty alert is received
        this.alerts = [];
        this.cdr.detectChanges();
        return;
      }

      // add alert to array unique by code, type, and message
      if (!this.alerts.some((item) => (item.type === alert.type) && (item.code === alert.code) && (item.message === alert.message))) {
        this.alerts = [...this.alerts, alert];
        this.cdr.detectChanges();
      }

      // remove alert after
      if (this.timeout) {
        setTimeout(() => this.removeAlert(alert), this.timeout);
      }
    });
  }

  removeAlert(alert: Alert) {
    this.alerts = this.alerts.filter(x => x !== alert);
    this.cdr.detectChanges();
  }

  alertType(alert: Alert) {
    if (!alert) {
      return;
    }

    // return css class based on alert type
    switch (alert.type) {
      case AlertType.Success:
        return 'success';
      case AlertType.Error:
        return 'danger';
      case AlertType.Info:
        return 'info';
      case AlertType.Warning:
        return 'warning';
    }
  }

  toastClass(alert: Alert): string {
    const type = this.alertType(alert) || 'info';
    return `xcm-notification-toast xcm-notification-${type}`;
  }

  ngOnDestroy() {
    if (this.alertSub) {
      this.alertSub.unsubscribe();
    }
  }
}
